import { render, staticRenderFns } from "./staffDialog.vue?vue&type=template&id=369a63d8&"
import script from "./staffDialog.vue?vue&type=script&lang=js&"
export * from "./staffDialog.vue?vue&type=script&lang=js&"
import style0 from "./staffDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports